export default __webpack_public_path__ + "imgs/music.b7f3ce702efdb2d3c4baad72c5de3a92.svg";